import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { NoteContent } from "features/notes/NoteContent";
import { selectIsClient } from 'features/user/userSlice';
import { useState } from "react";
import { useSelector } from 'react-redux';

const EnterCommentDialog = ({ open, onCancel, onSave }) => {

    const isClient = useSelector(selectIsClient);

    const [note, setNote] = useState({ content: '', viewByClient: isClient ? true : false });

    const handleSave = async () => {
        await onSave(note);
        setNote({ content: '', viewByClient: isClient ? true : false });
    }

    const handleNoteChange = (field, value) => {
        setNote({ ...note, [field]: value });
    }

    return (
        <Dialog open={open} maxWidth='sm'>
            <DialogTitle>
                Please enter a comment before you save
            </DialogTitle>
            <DialogContent>
                <NoteContent content={note.content} onChange={handleNoteChange} viewByClient={note.viewByClient} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" disabled={!note.content}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EnterCommentDialog;